import React from 'react';
import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {doppeActionTypeExternalFormMetadata} from './doppe-action-type-external-form-metadata';

export const doppeActionTypeExternalFormViewerMetadata = doppeActionTypeDefineViewerMetadata(doppeActionTypeExternalFormMetadata, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeExternalFormWidget: (await import('./doppe-action-type-external-form-widget/doppe-action-type-external-form-widget')).DoppeActionTypeExternalFormWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeExternalFormWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeExternalFormWidget
                {...renderProps}
            />
        )
    }
});
